import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Report } from '../../../graphql/reports.datatypes';

interface ReportData {
  reportByKey: Report
}

export const gqlReport = `
    id
    name
    query
    url_key
    shared
`;

export const GET_REPORT_QUERY = gql`
    query getReportByKey($url_key: String!){
        reportByKey(url_key: $url_key){
          ${gqlReport}
        }
    }
`;

export const getReportByKey = (urlKey: string) => useQuery<ReportData>(
  GET_REPORT_QUERY,
  {
    variables: {url_key: urlKey}
  }
);

export default getReportByKey;